import { CourseDefaultViewType } from './../../models/enums/CourseDefaultViewType';
import { FilterCourses } from './../../pages/course/filter';
import { UserHomeService } from './../../api/user-home-service';
/* tslint:disable */
import { actions } from '../constants/coursePage';
import * as types from '../../models/action/coursePage';
import { GetActivitiesType } from '../../models/enums/GetActivityType';
import { IActivityCard, IActivityCardItems } from '../../models/components/activity-card';
import { IFilterStudent, IStudentItem } from '../../models/components/course-student-list';
import { IFileView } from '../../models/components/course-files';
import { IPagedQuery, IPagedQueryS } from '../../models/components/paginate';
import { ActivityType } from '../../models/enums/ActivityType';
import { SurveyQuestionType } from '../../models/enums/SurveyQuestionType';
import { CourseContentMenuType } from '../../models/enums/CourseContentMenuType';
import { string } from 'prop-types';
import { UploadRelationType } from '../../models/enums/UploadRelationType';
import IActivitiesByWeekBody from '../../models/components/course-content-menu';

import { Log } from 'ng2-logger';
import { IAction } from '../../models/action/core';
import ICourseContentTermWeeks from '../../models/components/course-content-termweeks';
import { IActivityFilters } from '../../models/action/coursePage';
import { ICourseContentWeekActivitesBody } from '../../models/components/course-content-weekactivities';
import { number } from 'yup';
import { GradeInfoTypes } from '../../models/enums/GradeInfoTypes';
const _logger = Log.create('coursePage Saga');

//#region "Course Main Page ClassId & ActivitId"
export function getCoursePageData(
    activityId: string,
    classId: string,
    homePageSelectedTab: string,
    actId: string | null | undefined,
    weekOrUnitId: string | null | undefined
): types.ICoursePage {
    return {
        homePageSelectedTab,
        activityId,
        classId,
        actId,
        weekOrUnitId,
        timestamp: Date.now(),
        type: actions.GET_COURSE_PAGE_DATA,
    };
}

export function setCoursePageData(
    coursePageActivityId: string,
    coursePageClassId: string,
    homePageSelectedTab: string,
    actId: string | null | undefined,
    weekOrUnitId: string | null | undefined
): types.ICoursePageSetAction {
    return {
        homePageSelectedTab,
        coursePageActivityId,
        coursePageClassId,
        actId,
        weekOrUnitId,
        timestamp: Date.now(),
        type: actions.SET_COURSE_PAGE_DATA,
    };
}

export function getCourseClassesData(
    courseId: string | null,
    filters: IPagedQueryS,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.ICourseClassesDataGetAction {
    return {
        courseId,
        filters,
        timestamp: Date.now(),
        type: actions.GET_COURSE_CLASSES_DATA,
        spinnerId,
        spinnerType
    };
}

export function setCourseClassesData(
    userMyClasses: {
        results: Array<{
            courseActiveStatus: number | null,
            className: string | null,
            classId: string | null,
            courseName: string | null,
            termName?: string | null,
            courseId: string | null,
            endDate?: Date | null,
            startDate?: Date | null,
            totalCount?: number | null,
            programName: string | null
        }> | null;
        filters: {
            total: number | null,
            page: number | null,
            take: number | null,
        } | null;
    } | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.ICourseClassesDataSetAction {
    return {
        userMyClasses,
        timestamp: Date.now(),
        type: actions.SET_COURSE_CLASSES_DATA,
        spinnerId,
        spinnerType
    };
}

export function setActId(
    actId: string | null | undefined
): types.ISetActId {
    return {
        actId,
        timestamp: Date.now(),
        type: actions.SET_ACTID,
    };
}
//#endregion "Course Main Page ClassId & ActivitId"

//#region "Course Main Page Header Information"
export function getCoursePageHeaderInformationData(
    classId: string,
    activityId: string,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    callback?: any
): types.ICoursePageHeaderInfoAction {
    return {
        classId,
        activityId,
        timestamp: Date.now(),
        type: actions.GET_COURSE_PAGE_HEADERINFORMATOIN_DATA,
        spinnerId,
        spinnerType,
        callback
    };
}

export function setCoursePageHeaderInformationData(
    coursePageclassInformation: {
        courseName: string | null;
        programName: string | null;
        teacher: Array<any> | null;
        teachers: Array<any> | null;
        logoUrl: string | null;
        courseDescription: string | null;
        isWeekly: boolean | null;
        startDate: Date | null;
        endDate: Date | null;
        classId: string | null;
        classDescription: string | null;
        activityViewType: string | null;
        courseDefaultView: CourseDefaultViewType | null;
    } | null,
    coursePagefirstTwoTeachers: Array<string> | null,
    lessonHeaderIsLoaded: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.ICoursePageHeaderInfoSetAction {
    return {
        coursePageclassInformation,
        coursePagefirstTwoTeachers,
        lessonHeaderIsLoaded,
        timestamp: Date.now(),
        type: actions.SET_COURSE_PAGE_HEADERINFORMATOIN_DATA,
        spinnerId,
        spinnerType,
    };
}
//#endregion "End Course Main Page Header Information"

//#region "Course Class Activity Progress"
export function getCourseClassActivityProgress(
    classId: string,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.IClassActivityProgressAction {
    return {
        classId,
        timestamp: Date.now(),
        type: actions.GET_COURSE_CLASS_ACTIVITY_PROGRESS_DATA,
        spinnerId,
        spinnerType,
    };
}

export function setCourseClassActivityProgress(
    activityProgressIsLoaded: boolean,
    activityProgressRecords: Array<{ completedCount: number | null; totalCount: number | null; type: number | null }> | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.IClassActivityProgressSetAction {
    return {
        activityProgressRecords,
        activityProgressIsLoaded,
        timestamp: Date.now(),
        type: actions.SET_COURSE_CLASS_ACTIVITY_PROGRESS_DATA,
        spinnerId,
        spinnerType,
    };
}
//#endregion "End Course Class Activity Progress"

//#region "Course Page Change Class"
export function getCourseChangeClass(coursePageClassId: string, callBack: any): types.ICourseChangeClassAction {
    return {
        coursePageClassId,
        callBack,
        timestamp: Date.now(),
        type: actions.GET_COURSE_PAGE_CHANGE_CLASS,
    };
}

export function setCourseChangeClass(coursePageClassId: string): types.ICourseChangeClassSetAction {
    return {
        coursePageClassId,
        timestamp: Date.now(),
        type: actions.SET_COURSE_PAGE_CHANGE_CLASS,
    };
}

export function setCourseClasses(coursePageActivityId: string, classes: Array<any> | null): types.ICourseClassesSetAction {
    return {
        coursePageActivityId,
        classes,
        timestamp: Date.now(),
        type: actions.SET_COURSE_PAGE_CLASSES,
    };
}
//#endregion "End Course Page Change Class"

//#region "Course Page Selected Tab"
export function getCoursePageSelectedTab(homePageSelectedTab: string): types.ICoursePageSelectedTabAction {
    return {
        homePageSelectedTab,
        timestamp: Date.now(),
        type: actions.GET_COURSE_HOME_PAGE_SELECTED_TAB,
    };
}

export function setCoursePageSelectedTab(homePageSelectedTab: string): types.ICoursePageSelectedTabSetAction {
    return {
        homePageSelectedTab,
        timestamp: Date.now(),
        type: actions.SET_COURSE_HOME_PAGE_SELECTED_TAB,
    };
}
//#endregion "End Course Page Selected Tab"

//#region "Course Home Page Incoming Activities"
export function getCoursePageIncomingActivities(
    coursePageClassId: string,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.ICoursePageIncomingActivityAction {
    return {
        coursePageClassId,
        timestamp: Date.now(),
        type: actions.GET_COURSE_PAGE_INCOMING_ACTIVITY,
        spinnerId,
        spinnerType,
    };
}

export function setCoursePageIncomingActivities(
    incomingActivities:
        Array<{ activityName: string | null; activityType: string | null; dueDate: Date | null; activityTypeNumber: number | null; activityBeginDate: Date; activityEndDate: Date }>
        | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.ICoursePageIncomingActivitySetAction {
    return {
        incomingActivities,
        timestamp: Date.now(),
        type: actions.SET_COURSE_PAGE_INCOMING_ACTIVITY,
        spinnerId,
        spinnerType,
    };
}
//#endregion "End Course Home Page Incoming Activities"

//#region "Course Home Page Announcements"
export function getCoursePageAnnouncementsAction(
    coursePageClassId: string,
    coursePageActivityId: string,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.ICoursePageAnnouncementsAction {
    return {
        coursePageClassId,
        coursePageActivityId,
        timestamp: Date.now(),
        type: actions.GET_COURSE_PAGE_ANNOUNCEMENTS,
        spinnerId,
        spinnerType,
    };
}

export function setCoursePageAnnouncementsAction(
    announcements: Array<{ subject: string | null; body: string | null; startDate: Date | null; endDate: Date | null }> | null,
    announcementIsLoaded: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.ICoursePageAnnouncementsSetAction {
    return {
        announcementIsLoaded,
        announcements,
        timestamp: Date.now(),
        type: actions.SET_COURSE_PAGE_ANNOUNCEMENTS,
        spinnerId,
        spinnerType,
    };
}
//#endregion "End Course Home Page Announcements"

//#region "Course Home Page Current Week Activities"
export function getCoursePageCurrentWeekAction(
    coursePageClassId: string,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    callback?: (value: any) => void
): types.ICoursePageCurrentWeekAction {
    return {
        coursePageClassId,
        timestamp: Date.now(),
        type: actions.GET_COURSE_PAGE_CURRENT_WEEK_ACTIVITIES,
        spinnerId,
        spinnerType,
        callback
    };
}

export function setCoursePageCurrentWeekSetAction(
    currentWeekActivities: {
        activities: Array<{ activityId: string, activityName: string | null; activityType: string | null }>;
        classDescription: string | null;
        startDate: Date | null;
        endDate: Date | null | null;
        termWeekId: string;
        totalCount: number;
    } | null,
    currentWeekActivitiesIsLoaded: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.ICoursePageCurrentWeekSetAction {
    return {
        currentWeekActivities,
        currentWeekActivitiesIsLoaded,
        timestamp: Date.now(),
        type: actions.SET_COURSE_PAGE_CURRENT_WEEK_ACTIVITIES,
        spinnerId,
        spinnerType,
    };
}
//#endregion "End Course Home Page Current Week Activities"

//#region "Course page course contents weeks"
export function getCourseContentsWeeksAction(coursePageClassId: string): types.ICourseContentsWeeksAction {
    return {
        coursePageClassId,
        timestamp: Date.now(),
        type: actions.GET_COURSE_PAGE_COURSECONTENTS_WEEKS,
    };
}

export function setCourseContentsWeeksAction(
    courseContentsWeeks:
        Array<
            {
                notWeekly: boolean;
                notWeeklyName: string | null;
                termId: string | null;
                termWeekId: string | null;
                week: number | null;
                endDate: Date | null;
                startDate: Date | null;
                genaralActivity: boolean;
            }
        >
        | null,
    courseContentsWeeksLoading: boolean
): types.ICourseContentsWeeksSetAction {
    return {
        courseContentsWeeks,
        courseContentsWeeksLoading,
        timestamp: Date.now(),
        type: actions.SET_COURSE_PAGE_COURSECONTENTS_WEEKS,
    };
}
//#endregion "Course page course contents weeks"

//#region "Course page course contents weeks activities"
export function getCourseContentsWeekActivitiesAction(
    classId: string,
    courseId: string,
    isWeekly: boolean,
    skip: number,
    take: number,
    termWeekId: string | null,
    GetOnlyPassiveList: boolean,
    weekZero: boolean,
    activeTabGuid: string | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    isThisWeek?: boolean,
    orderBy?: string,
    callback?: (value: any) => void
): types.ICourseContentsWeekActivitiesAction {
    return {
        classId,
        courseId,
        isWeekly,
        skip,
        take,
        termWeekId,
        GetOnlyPassiveList,
        weekZero,
        activeTabGuid,
        timestamp: Date.now(),
        type: actions.GET_COURSE_PAGE_COURSECONTENTS_WEEKS_ACTIVITIES,
        spinnerId,
        spinnerType,
        isThisWeek,
        orderBy,
        callback
    };
}

export function setGettingWeeks(isGettingWeeks: boolean): types.ISetGettingWeeks {
    return {
        isGettingWeeks,
        timestamp: Date.now(),
        type: actions.SET_GETTING_WEEKS
    }
}
export function setPassiveButton(
    isPassiveButton: boolean,
    callback?: (value: any) => void,
): types.ICourseContentPassiveButtonAction {
    return {
        isPassiveButton,
        callback,
        timestamp: Date.now(),
        type: actions.SET_COURSE_PAGE_PASSİVE_ACTIVITIES_BUTTON,
    };
}

export function setCourseContentsWeekActivitiesAction(
    courseContentWeekActivities:
        Array<
            {
                activityId: string;
                name: string;
                activityType: string;
                prerequisiteActivity: number | null;
                prerequisiteActivityName: string | null;
                termWeekId: string | null | undefined;
                beginDate?: any;
                endDate?: any;
            }
        >
        | null,
    activeTabGuid: string | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    isThisWeek?: boolean,
    termWeekId?: string | null,
): types.ICourseContentsWeekActivitiesSetAction {
    return {
        courseContentWeekActivities,
        activeTabGuid,
        timestamp: Date.now(),
        type: actions.SET_COURSE_PAGE_COURSECONTENTS_WEEKS_ACTIVITIES,
        spinnerId,
        spinnerType,
        isThisWeek,
        termWeekId,
    };
}
//#endregion "Course page course contents weeks activities"

//#region "Course page course contents  activities"
// tslint:disable-next-line:no-shadowed-variable
export function getCourseContentsActivityCardAction(
    GetActivitiesType: GetActivitiesType,
    ClassId: string | null,
    CourseId: string,
    ActivityId: string | null,
    TermWeekId: string | null,
    Take: number,
    Skip: number,
    spinnerId: string,
    spinnerType: 'get' | 'set',
    ContextId?: string,
    GetOnlyPassiveList?: boolean,
    weekZero?: boolean,
    activeStatus?: number,
    callback?: () => void,
    activityFilters?: types.IActivityFilters,
    spinnerIds?: any
): types.ICourseContentsActivirtyCardAction {
    return {
        ActivityId,
        ClassId,
        CourseId,
        GetActivitiesType,
        Skip,
        Take,
        TermWeekId,
        timestamp: Date.now(),
        type: actions.GET_COURSE_PAGE_ACTIVITY_CARDS,
        spinnerId,
        spinnerType,
        ContextId,
        GetOnlyPassiveList,
        weekZero,
        activeStatus,
        activityFilters,
        callback,
        spinnerIds
    };
}

export function setActivityFiltersAction(
    activityFilters?: types.IActivityFilters,
    spinnerId?: string | null,
    spinnerType?: 'get' | 'set'
): types.ISetActivityFiltersAction {
    return {
        activityFilters,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_ACTIVITY_FILTERS
    };
}

export function setCourseContentsActivityCardAction(
    courseContentActivityCardLoading: boolean,
    activityCard: IActivityCard | null,
    spinnerId?: string,
    spinnerType?: 'set' | 'get',
    spinnerIds?: any
): types.ICourseContentsActivirtyCardSetAction {
    return {
        activityCard,
        courseContentActivityCardLoading,
        timestamp: Date.now(),
        type: actions.SET_COURSE_PAGE_ACTIVITY_CARDS,
        spinnerId,
        spinnerType,
        spinnerIds
    };
}

export function setCourseContentActivityCardRefresh(): IAction {
    return {
        timestamp: Date.now(),
        type: actions.SET_COURSE_PAGE_ACTIVITY_CARD_REFRESH,
    };
}
//#endregion "Course page course contents  activities"

//#region "Course page course contents  activities"
// tslint:disable-next-line:no-shadowed-variable
export function getDeleteActivityAction(
    courseContentMenuType: CourseContentMenuType,
    classId: string,
    courseId: string,
    activityId: string,
    activityType: ActivityType,
    activityCardItems: Array<IActivityCardItems> | null,
    courseContentWeekActivities?: Array<
        { activityId: string; name: string; activityType: string; prerequisiteActivity: number; prerequisiteActivityName: string }
    > | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    callback?: any,
    projectActivityId?: string,
    afterDeletedActivityIndex?: number
): types.IDeleteActivityAction {
    return {
        courseContentMenuType,
        classId,
        courseId,
        activityId,
        activityType,
        courseContentWeekActivities,
        activityCardItems,
        timestamp: Date.now(),
        type: actions.GET_COURSE_PAGE_DELETE_ACTIVITY,
        spinnerId,
        spinnerType,
        callback,
        projectActivityId,
        afterDeletedActivityIndex
    };
}

export function setDeleteActivityAction(
    deleteActivityLoading: boolean,
    deletedActivityId: string,
    activityCardItems: Array<IActivityCardItems> | null,
    courseContentActivityCardLoading: boolean,
    courseContentWeekActivitiesLoading: boolean,
    courseContentWeekActivities?: Array<
        { activityId: string; name: string; activityType: string; prerequisiteActivity: number; prerequisiteActivityName: string }
    > | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.IDeleteActivitySetAction {
    return {
        deleteActivityLoading,
        deletedActivityId,
        activityCardItems,
        courseContentActivityCardLoading,
        courseContentWeekActivities,
        courseContentWeekActivitiesLoading,
        timestamp: Date.now(),
        type: actions.SET_COURSE_PAGE_DELETE_ACTIVITY,
        spinnerId,
        spinnerType,
    };
}
//#endregion "Course page course contents  activities"

//#region "Survey choices "
// tslint:disable-next-line:no-shadowed-variable
export function getSurveyChoices(
    surveyChoices: Array<{ questionId: string; groupId?: string; choiceId?: string; textualAnswer?: string; questionType: SurveyQuestionType }>
): types.ISurveyChoicesAction {
    return {
        surveyChoices,
        timestamp: Date.now(),
        type: actions.GET_SURVEY_CHOICES,
    };
}

export function setSurveyChoices(
    surveyChoices: Array<{ questionId: string; groupId?: string; choiceId?: string; textualAnswer?: string; questionType: SurveyQuestionType }>
): types.IISurveyChoicesSetAction {
    return {
        surveyChoices,
        timestamp: Date.now(),
        type: actions.SET_SURVEY_CHOICES,
    };
}
//#endregion "Survey choices "

//#region "Course content menu "
export function getCourseContentMenu(
    classId: string,
    courseId?: string,
    weekId?: string,
    reset?: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    callback?: any
): types.ICourseContentMenuAction {
    return {
        classId,
        courseId,
        weekId,
        reset,
        timestamp: Date.now(),
        type: actions.GET_COURSE_CONTENT_MENU,
        spinnerId,
        spinnerType,
        callback
    };
}

export function setCourseContentMenu(
    termWeeks:
        Array<
            {
                notWeekly: boolean;
                notWeeklyName: string | null;
                termId: string | null;
                termWeekId: string | null;
                week: number | null;
                endDate: Date | null;
                startDate: Date | null;
                itemGuid: string;
                genaralActivity: boolean;
            }
        >
        | null,
    courseContentMenuLoading: boolean,
    menuType: CourseContentMenuType | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.ICourseContentMenuSetAction {
    return {
        courseContentMenuLoading,
        menuType,
        termWeeks,
        timestamp: Date.now(),
        type: actions.SET_COURSE_CONTENT_MENU,
        spinnerId,
        spinnerType,
    };
}

export function getActivityIdsByWeeks(
    classId: string,
    weekId?: string,
    reset?: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    callback?: any,
    isCache?: boolean,
    courseId?: string
): types.ICourseContentMenuAction {
    return {
        classId,
        weekId,
        reset,
        timestamp: Date.now(),
        type: actions.GET_ACTIVITY_IDS_BY_WEEKS,
        spinnerId,
        spinnerType,
        callback,
        isCache,
        courseId
    };
}

export function setActivityIdsByWeeks(
    termWeeks:
        Array<
            {
                activitiesByWeek: Array<IActivitiesByWeekBody> | null;
                notWeekly: boolean;
                notWeeklyName: string | null;
                termId: string | null;
                termWeekId: string | null;
                week: number | null;
                endDate: Date | null;
                startDate: Date | null;
                itemGuid: string;
                genaralActivity: boolean;
            }
        >
        | null,
    courseContentMenuLoading: boolean,
    menuType: CourseContentMenuType | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.IActivtyIdsByWeeksSetAction {
    return {
        courseContentMenuLoading,
        menuType,
        termWeeks,
        timestamp: Date.now(),
        type: actions.SET_ACTIVITY_IDS_BY_WEEKS,
        spinnerId,
        spinnerType,
    };
}
//#endregion Course content menu "

//#region "Course Student List Tab"
export function getCourseStudentList(
    classId: string,
    filters?: IFilterStudent,
    reset?: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.ICoursePageStudentListAction {
    return {
        classId,
        ...filters,
        reset,
        timestamp: Date.now(),
        type: actions.GET_COURSE_STUDENT_LIST,
        spinnerId,
        spinnerType,
    };
}

export function setCourseStudentList(
    results: Array<IStudentItem> | null,
    filters: IFilterStudent | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.ICoursePageStudentListSetAction {
    return {
        results,
        filters,
        timestamp: Date.now(),
        type: actions.SET_COURSE_STUDENT_LIST,
        spinnerId,
        spinnerType,
    };
}

//#region "Course Files Tab"
export function getCourseFiles(
    classId: string,
    uploadRelationType: UploadRelationType,
    courseId: string,
    filters?: IPagedQuery,
    reset?: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
): types.ICoursePageFilesAction {
    return {
        classId,
        ...filters,
        reset,
        timestamp: Date.now(),
        type: actions.GET_COURSE_FILES,
        spinnerId,
        spinnerType,
        uploadRelationType,
        courseId
    };
}

export function setCourseFiles(
    results: Array<IFileView> | null,
    filters: IPagedQuery | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.ICoursePageFilesSetAction {
    return {
        results,
        filters,
        timestamp: Date.now(),
        type: actions.SET_COURSE_FILES,
        spinnerId,
        spinnerType,
    };
}

//#endregion "Course Files Tab"

//#region "Course Class Activity Report Modal"
export function getCourseClassActivityReport(
    classId: string,
    activityId: string,
    groupId: string,
    reset?: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): any {
    return {
        classId,
        activityId,
        groupId,
        reset,
        timestamp: Date.now(),
        type: actions.GET_COURSE_CLASS_ACTIVITY_REPORT,
        spinnerId,
        spinnerType,
    };
}

export function setCourseClassActivityReport(stats: any | null, spinnerId?: string, spinnerType?: 'get' | 'set'): any {
    return {
        stats,
        timestamp: Date.now(),
        type: actions.SET_COURSE_CLASS_ACTIVITY_REPORT,
        spinnerId,
        spinnerType,
    };
}
//#endregion "Course Activity Stats Modal"

//#region "Course Class Activity Report Download"
export function getClassActivityReportDownload(
    classId: string,
    activityId: string,
    reset?: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): any {
    return {
        classId,
        activityId,
        reset,
        timestamp: Date.now(),
        type: actions.GET_COURSE_CLASS_ACTIVITY_REPORT_DOWNLOAD,
        spinnerId,
        spinnerType,
    };
}

export function setClassActivityReportDownload(status: boolean | null, spinnerId?: string, spinnerType?: 'get' | 'set'): any {
    return {
        status,
        timestamp: Date.now(),
        type: actions.SET_COURSE_CLASS_ACTIVITY_REPORT_DOWNLOAD,
        spinnerId,
        spinnerType,
    };
}

//#endregion "Course Activity Stats Modal"

//#region "Course Assignment Grade Information"
export function getAssignmentGradeInformation(
    classId: string,
    activityId: string,
    groupId: string,
    reset?: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): any {
    return {
        classId,
        activityId,
        groupId,
        reset,
        timestamp: Date.now(),
        type: actions.GET_COURSE_ASSIGNMENT_GRADE_INFORMATION,
        spinnerId,
        spinnerType,
    };
}

export function setAssignmentGradeInformation(
    gradeInformation: any,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): any {
    return {
        gradeInformation,
        timestamp: Date.now(),
        type: actions.SET_COURSE_ASSIGNMENT_GRADE_INFORMATION,
        spinnerId,
        spinnerType,
    };
}

//#endregion "Course Assignment Activity Grade"

//#region "Course Assignment Grade Student List"
export function getAssignmentGradeStudentList(
    classId: string,
    activityId: string,
    groupId: string,
    filters: IPagedQuery,
    gradeInfoType?: GradeInfoTypes,
    reset?: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): any {
    return {
        classId,
        activityId,
        groupId,
        ...filters,
        gradeInfoType,
        reset,
        timestamp: Date.now(),
        type: actions.GET_COURSE_ASSIGNMENT_STUDENT_LIST,
        spinnerId,
        spinnerType
    };
}

export function setAssignmentGradeStudentList(
    result: {
        results: Array<IStudentItem> | null,
        filters: IFilterStudent | null,
    } | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): any {
    return {
        result,
        timestamp: Date.now(),
        type: actions.SET_COURSE_ASSIGNMENT_STUDENT_LIST,
        spinnerId,
        spinnerType,
    };
}

//#endregion "Course Assignment Student List"

//#region "Course Assignment Grade Save Grade"
export function getAssignmentGradeSaveGrade(
    userId: string,
    score: number,
    classId: string,
    activityId: string,
    reset?: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): any {
    return {
        userId,
        score,
        classId,
        activityId,
        reset,
        timestamp: Date.now(),
        type: actions.GET_COURSE_ASSIGNMENT_SAVE_GRADE,
        spinnerId,
        spinnerType,
    };
}

export function setAssignmentGradeSaveGrade(
    result: {
        userID: string;
        classId: string;
        activityId: string;
        status: string;
    } | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): any {
    return {
        result,
        timestamp: Date.now(),
        type: actions.SET_COURSE_ASSIGNMENT_SAVE_GRADE,
        spinnerId,
        spinnerType,
    };
}

//#endregion "Course Class Activity Save Grade"

//#region "Course Assignment Grade Download All"
export function getAssignmentGradeDownloadAll(
    classId: string,
    activityId: string,
    reset?: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): any {
    return {
        classId,
        activityId,
        reset,
        timestamp: Date.now(),
        type: actions.GET_COURSE_ASSIGNMENT_DOWNLOAD_ALL,
        spinnerId,
        spinnerType,
    };
}

export function setAssignmentGradeDownloadAll(
    result: boolean | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): any {
    return {
        result,
        timestamp: Date.now(),
        type: actions.SET_COURSE_ASSIGNMENT_DOWNLOAD_ALL,
        spinnerId,
        spinnerType,
    };
}

//#endregion "Course Class Activity Save Grade"

export function getAssignmentBulkGrade(
    classId: string,
    activityId: string,
    score?: string,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): any {
    return {
        classId,
        activityId,
        score,
        timestamp: Date.now(),
        type: actions.GET_COURSE_BULK_GRADE,
        spinnerId,
        spinnerType,
    };
}

export function getProgressPercent(
    classId: string,
    userId: string,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): any {
    return {
        classId,
        userId,
        timestamp: Date.now(),
        type: actions.GET_PROGRESS_PERCENT,
        spinnerId,
        spinnerType,
    };
}

export function setProgressPercent(
    progress: number | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): types.IGetProgressPercent {
    return {
        progress,
        spinnerId,
        type: actions.SET_PROGRESS_PERCENT,
        spinnerType,
        timestamp: Date.now()
    };
}

export function getMyActivityStatsGetAction(Filters: types.IFilters, spinnerId?: string, spinnerType?: 'get' | 'set'): types.IGetMyActivityStats {
    return {
        Filters,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_MY_ACTIVITY_STATS
    };
}

export function getMyActivityStatsSetAction(MyActivityStats: Array<types.IMyActivityStats> | null, spinnerId?: string, spinnerType?: 'get' | 'set'): types.ISetMyActivityStats {
    return {
        MyActivityStats,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_MY_ACTIVITY_STATS
    };
}

export function getActivityStatusSetAction(activityId: string, status: number, spinnerId?: string, callback?: any, spinnerType?: 'get' | 'set'): types.ISetActivityPassive {
    return {
        activityId,
        status,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_ACTIVITY_STATUS,
        callback
    };
}

export function setShowAddActivity(
    isShowActivityAdd: boolean
): types.ISetShowAddActivity {
    return {
        isShowActivityAdd,
        timestamp: Date.now(),
        type: actions.SET_SHOW_ADD_ACTIVITY,
    };
}

export function setActivityPassive(
    activityId: string,
    status: number,
): types.ISetActivityPassive {
    return {
        activityId,
        status,
        timestamp: Date.now(),
        type: actions.SET_ACTIVITY_STATUS,
    };
}

export function SetActivityIdAfterAdd(activityId: string): types.ISetActivityIdAfterAdd {
    return {
        activityId,
        timestamp: Date.now(),
        type: actions.SET_ACTIVITY_ID_AFTER_ADD
    };
}

export function SetUpdateInput(id: string, value: string, apiUrl: string, apiMethod: string, classId?: string, callback?: (value: any) => void, courseId?: string): types.ISetUpdateInput {
    return {
        id,
        value,
        apiUrl,
        apiMethod,
        classId,
        courseId,
        timestamp: Date.now(),
        type: actions.SET_UPDATE_INPUT,
        callback
    };
}

export function ActivityReportDetailGetAction(ActivityId: string, ClassId: string, spinnerId?: string, spinnerType?: 'get' | 'set'): types.IGetActivtyReportDetail {
    return {
        ActivityId,
        ClassId,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ACTIVITY_REPORT_DETAIL_GET_ACTION
    };
}

export function ActivityReportDetailSetAction(ActivityReportDetail: types.ISetActivtyReportDetail | null, spinnerId?: string, spinnerType?: 'get' | 'set'): types.ISetActivtyReportDetails {
    return {
        ActivityReportDetail,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ACTIVITY_REPORT_DETAIL_SET_ACTION
    };
}

export function SetTriggerGetActivities(searchData: IActivityCard, callback?: any, spinnerId?: string, spinnerType?: 'get' | 'set', courseDefaultView?: CourseDefaultViewType | null, nonWeeklyCourse?: boolean | null): types.ITriggerGetActivities {
    return {
        searchData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_TRIGGER_GET_ACTIVITIES_ACTION,
        callback,
        courseDefaultView,
        nonWeeklyCourse
    }
}

export function SetTriggerWeekOnClick(itemKeyParam?: string, weekIdParam?: string, courseContentMenuType?: CourseContentMenuType, activeTabGuid?: string, courseContentTermWeeks?: Array<ICourseContentTermWeeks> | null, hasFilter?: boolean, classId?: string, courseId?: string, sort?: string, activityFilters?: IActivityFilters, courseContentWeekActivities?: Array<ICourseContentWeekActivitesBody> | null, courseDefaultView?: CourseDefaultViewType | null, callback?: (value: any) => void, spinnerId?: string, spinnerType?: 'get' | 'set'): types.ITriggerWeekActivities {
    return {
        itemKeyParam,
        weekIdParam,
        courseContentMenuType,
        activeTabGuid,
        courseContentTermWeeks,
        hasFilter,
        classId,
        courseId,
        sort,
        activityFilters,
        courseContentWeekActivities,
        courseDefaultView,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.CLICK_WEEK_ACTIVITIES,
        callback
    }
}

export function SetActivitiesSorting(sortingKey: string, callback?: (value: any) => void, spinnerId?: string, spinnerType?: 'get' | 'set'): types.IActivitiesSorting {
    return {
        sortingKey,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_SORTING_ACTIVITIES_ACTION,
        callback
    }
}

export function setTriggerCourseStar(CourseId: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: any) => void): types.ISetTriggerCourseStar {
    return {
        CourseId,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_TRIGGER_COURSE_STAR,
        callback
    }
}

export function setTriggerRemovePrerequisite(CourseId: string, ClassId: string, PrerequisiteIds: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: any) => void): types.ISetRemovePrerequisite {
    return {
        CourseId,
        ClassId,
        PrerequisiteIds,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_TRIGGER_REMOVE_PREREQUISITE,
        callback
    }
}

export function setCourseDefaultView(
    courseDefaultView: CourseDefaultViewType
): types.ISetCourseDefaultView {
    return {
        courseDefaultView,
        timestamp: Date.now(),
        type: actions.SET_COURSE_DEFAULT_VİEW,
    };
}

export function SetIsClickedWeek(
    isClickedWeek: boolean,
    spinnerId?: string, 
    spinnerType?: 'get' | 'set',
    callback?: (value: any) => void
): types.ISetIsClickedWeek {
    return {
        isClickedWeek,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_IS_CLICKED_WEEK,
        callback
    };
}

export function SetGetMoreActivities(
    getMoreActivities: boolean,
    spinnerId?: string, 
    spinnerType?: 'get' | 'set',
    callback?: (value: any) => void
): types.ISetGetMoreActivities {
    return {
        getMoreActivities,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_GET_MORE_ACTIVITIES,
        callback
    };
}

export function SetResetShowMoreCount(
    resetShowMoreCount: boolean,
    spinnerId?: string, 
    spinnerType?: 'get' | 'set',
    callback?: (value: any) => void
): types.ISetResetShowMoreCount {
    return {
        resetShowMoreCount,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_RESET_SHOW_MORE_COUNT,
        callback
    };
}